const Footer = () => {
  return (
    <footer className="bg-primary text-primary-foreground py-8 md:py-10">
      <div className="container max-w-6xl mx-auto container-padding">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-6 md:gap-4">
          <div className="space-y-2 flex-1">
            <div className="flex items-center">
              <span className="font-bold text-lg flex items-center">
                Central TG Inc. 센트럴티지
                <span style={{ fontSize: "70%" }} className="align-baseline">(주)</span>
                
              </span>
            </div>
            <p className="text-primary-foreground/80 text-sm leading-snug max-w-md">
              JAX<sup>®</sup> Transgenic 모델 공식 대리점
            </p>
          </div>
          
          <div className="space-y-1 flex-1 md:text-right">
            <div className="text-primary-foreground/80 text-sm">
              <div className="flex items-center md:justify-end mb-1">
                <span><strong>Tel</strong> +82-2-577-1684</span>
              </div>
              <div className="flex items-center md:justify-end mb-1">
                <span><strong>Fax</strong> +82-2-577-1865</span>
              </div>
              <div className="flex items-center md:justify-end mb-4">
                <span>info@CentralTG.co.kr</span>
              </div>
              <div className="flex items-start md:justify-end mb-1">
                <span>서울특별시 서초구 서초대로 396, 강남빌딩 2층 222호 (우)06619</span>
              </div>
              <div className="flex items-start md:justify-end">
                <span>#222, 2F, Gangnam Building, 396, Seocho-daero,<br />Seocho-gu, Seoul, Republic of Korea, 06619</span>
              </div>
            </div>
          </div>
        </div>
        
        <div className="border-t border-primary-foreground/20 mt-4 pt-4 text-center text-primary-foreground/80">
          <p className="text-xs">&copy; 2026 Central TG Inc. All rights reserved.<br />JAX<sup>®</sup> is a registered trademark of The Jackson Laboratory, used under license.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
